import axios from "axios";
import { rootPath } from "@/config/globalParam";
import { Message } from "element-ui";
import { encryptionWord } from "@/utils/crypto.js";
import UAParser from "ua-parser-js";
import Fingerprint2 from "fingerprintjs2";
/**
 *登录接口
 * url 请求全路径
 * param 参数
 */
const parser = new UAParser();
const { browser } = parser.getResult();
// 封装生成设备指纹的函数
const getDeviceId = () => {
  return new Promise(resolve => {
    if (window.requestIdleCallback) {
      requestIdleCallback(() => {
        Fingerprint2.get(
          {
            excludes: {
              webgl: true,
              webglVendorAndRenderer: true
            }
          },
          components => {
            const values = components.map(component => component.value);
            const murmur = Fingerprint2.x64hash128(values.join(""), 31);
            resolve(murmur);
          }
        );
      });
    } else {
      setTimeout(() => {
        Fingerprint2.get(
          {
            excludes: {
              webgl: true,
              webglVendorAndRenderer: true
            }
          },
          components => {
            const values = components.map(component => component.value);
            const murmur = Fingerprint2.x64hash128(values.join(""), 31);
            resolve(murmur);
          }
        );
      }, 500);
    }
  });
};
export default async (param = {}, url) => {
  var keyStr = encryptionWord({
    word: "la-platform-api:la-platform-api",
    type: "Base64"
  });
  // 生成设备指纹
  const deviceId = await getDeviceId();
  let config = {
    baseURL: rootPath,
    timeout: 1800000,
    responseType: "json",
    withCredentials: true, // 是否允许带cookie这些
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Basic " + keyStr,
      device: browser.name,
      deviceId: deviceId
    }
  }; //添加请求头

  console.log("请求参数666---", param);
  if (param.grant_type == "password") {
    var tempUrl =
      url +
      "?grant_type=" +
      param.grant_type +
      "&code=" +
      param.code +
      "&randomStr=" +
      param.randomStr;
    var temParam = {
      username: param.username,
      password: param.password
    };
  } else {
    tempUrl = url + "?grant_type=" + param.grant_type;
    temParam = {
      refresh_token: param.refresh_token
    };
  }

  const sendData = new URLSearchParams();
  sendData.append("username", temParam.username);
  sendData.append("password", temParam.password);

  return axios.post(tempUrl, sendData, config).then(res => {
    console.log("config1", config);
    //返回结果为空
    if (!res) {
      Message.error("发生错误！请重新操作");
      return;
    }
    //200成功,返回所有的数据，不同的页面对数据的处理不一样
    if (res.status == "200") {
      return res.data;
    } else {
      Message.error("请求发生错误，请联系管理员");
      return;
    }
  });
};
